import { render, staticRenderFns } from "./lp-app-card.vue?vue&type=template&id=164211dc&scoped=true&"
import script from "./lp-app-card.vue?vue&type=script&lang=js&"
export * from "./lp-app-card.vue?vue&type=script&lang=js&"
import style0 from "./lp-app-card.vue?vue&type=style&index=0&id=164211dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164211dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VHover,VImg})
